import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

SortOptions.propTypes = {
  sort: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  returnFunc: PropTypes.func.isRequired,
};

function SortOptions(props) {
  const handleChange = (event) => {
    props.returnFunc(event.target.value);
  };

  return (
    <div>
      <FormControl component="fieldset">
        <RadioGroup aria-label="sort options" name="sortOptions" value={props.sort} onChange={handleChange}>
          {props.fields.map((item, index) => {
            return <FormControlLabel value={item.field} control={<Radio size="small" />} label={item.label} key={index} />
          })}
        </RadioGroup>
      </FormControl>
    </div>
  )
}

export default SortOptions;
